import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from '../../../../environments/environment';
import { Area } from '../../constants/area';
import { GetTelerikReportModel } from '../models/getTelerikReport.model';
import { FileUtils } from '../../utilities/fileUtils';
import { CoreReportDTO } from '../models/coreReport.model';
import { EmailTemplateModel } from '../models/emailTemplate.model';
import { ContactEmailListModel } from '../models/contactEmailList.model';
import { SendEmailReportRequest, SendEmailReportResponse } from '../models/sendEmailReport.model';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TelerikReportService {

  constructor(private http: HttpClient) { }

  async generateReport(model: GetTelerikReportModel): Promise<Blob> {
    const url = `${environment.dotNetApiUrl}/${Area.telerik}/Reports`;
    const response = await this.http
      .post(url, model, { responseType: 'blob' })
      .toPromise();

    return response;
  }

  async downloadReport(model: GetTelerikReportModel) {
    const response = await this.generateReport(model);
    FileUtils.downloadFile(response, model.fileName);
  }

  getReportHistory(reportIdentifier: string): Observable<CoreReportDTO> {
    const url = `${environment.dotNetApiUrl}/${Area.telerik}/reports/history?reportIdentifier=${reportIdentifier}`;
    return this.http.get<CoreReportDTO>(url);
  }

  async getReportBlob(reportId: number, versionId: number): Promise<{ blob: Blob, fileName: string }> {
    const url = `${environment.dotNetApiUrl}/${Area.telerik}/reports/${reportId}/versions/${versionId}/download`;
    const response = await this.http.get(url, { responseType: 'blob', observe: 'response' }).toPromise();

    return { blob: response.body, fileName: response.headers.get('Content-Disposition').split('filename=')[1] };
  }

  async downloadReportVersion(reportId: number, versionId: number): Promise<void> {
    const response = await this.getReportBlob(reportId, versionId);

    FileUtils.downloadFile(response.blob, response.fileName);
  }

  async printReportVersion(reportId: number, versionId: number): Promise<void> {
    const response = await this.getReportBlob(reportId, versionId);
    await FileUtils.printFile(response.blob);
  }

  getEmailTemplateById(emailTemplateId: number): Observable<EmailTemplateModel> {
    const url = `${environment.dotNetApiUrl}/${Area.telerik}/Reports/GetEmailTemplateById?emailTemplateId=${emailTemplateId}`;
    return this.http.get<EmailTemplateModel>(url);
  }

  getCompanyInvoiceReceiverEmail(companyId: number): Observable<ContactEmailListModel> {
    const url = `${environment.dotNetApiUrl}/${Area.telerik}/Reports/GetCompanyInvoiceReceiverEmail?companyId=${companyId}`;
    return this.http.get<ContactEmailListModel>(url);
  }

  sendEmailReport(reportTypeId: number, request: SendEmailReportRequest): Promise<SendEmailReportResponse> {
    const url = `${environment.dotNetApiUrl}/${Area.telerik}/Reports/email/${reportTypeId}`;
    return this.http.post<SendEmailReportResponse>(url, request).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/telerik/services/telerikReport.service.ts